import { render, staticRenderFns } from "./Informatie.vue?vue&type=template&id=3fa3fb60&"
import script from "./Informatie.vue?vue&type=script&lang=js&"
export * from "./Informatie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default})
